import BaseWebUniversal, { BaseWebUniversalProps } from '../system/BaseWebUniversal';
import { Switch } from 'antd';
import { forwardRef, useEffect, useRef } from 'react';
import { columnsheadId } from '../system/columnshead';
import { CommonProps } from '../../../utilsTs/declareTypes';
import { useMergedRef } from '../hooks/general';
import FilesServerEdit from './FilesServerEdit';

export interface BaseFilesServerProps extends Pick<BaseWebUniversalProps, 'defaultService' | 'displayOptions' | 'editOptions' | 'sendPageData'>,
    Pick<CommonProps, 'closeModal'> {
};

const BaseFilesServer = forwardRef<any, BaseFilesServerProps>((props, ref) => {
    const internalRef = useRef<any>(undefined);
    /** 合并外部 ref 和内部 refLocal */
    const mergedRef = useMergedRef(internalRef, ref);
    /** api服务id */
    const apiId = 'filesServer';


    useEffect(() => {
    }, []);


    //表头
    const columnsHead = [
        {
            title: '服务器名称',
            dataIndex: 'serverName',
            sorter: true,
        },
        {
            title: '服务器地址',
            dataIndex: 'serverUrl',
        },
        {
            title: '服务器端口',
            dataIndex: 'port',
        },
        {
            title: '默认',
            dataIndex: 'isDefault',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '默认服务号',
            dataIndex: 'defaultServiceId',
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: BaseWebUniversalProps = {
        ...props,
        titleName: '文件服务器',
        apiId,
        columns,
        editOptions: {
            Editor: FilesServerEdit
        }
    };

    return (
        <BaseWebUniversal {...extendProps} ref={mergedRef} />
    )
});

export default BaseFilesServer;
